import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import NavMenu from './NavbarMenu'
import DefaultButton from '../Button/Button'
import { FaSun, FaMoon } from 'react-icons/fa'
import SafeltoLogo from '../../assets/icons/SafeltoLogo'
import { DarkModeProps } from '../../interfaces/common'
import HamburgerImg from '../../assets/icons/HamburgerImg'
import MobileNavLinks from './MobileNavLinks'
import CloseImg from '../../assets/icons/CloseImg '
import { residentPwaLink } from '../../constants'


const NewNavbar = ({ isDarkMode, toggleDarkMode }: DarkModeProps) => {
  const location = useLocation()
  // const darkModeEnabledPages = React.useMemo(() => ['/'], [])
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false)

  // useEffect(() => {
  //   const isDarkModePage = darkModeEnabledPages.includes(location.pathname)
  //   if (isDarkModePage && isDarkMode) {
  //     document.documentElement.classList.add('dark')
  //   } else {
  //     document.documentElement.classList.remove('dark')
  //   }
  // }, [isDarkMode, location.pathname, darkModeEnabledPages])

  const toggleMobileMenu = () => setMobileMenuOpen((v) => !v)

  return (
    <nav className="fixed top-0 left-0 z-50 w-full bg-white dark:bg-black h-[70px] px-4 sm:px-6 lg:px-10 py-4">
      <div className="max-w-7xl mx-auto flex justify-between items-center h-full">
        {/* Logo */}
        <Link to="/" className="flex-shrink-0">
          <SafeltoLogo className="fill-black dark:fill-gray-300 w-28" />
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          <NavMenu />
        </div>

        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center gap-3">
          <a
            href={residentPwaLink()}
            className="px-2 text-base font-medium text-black dark:text-gray-300 hover:font-bold transition-all duration-300"
          >
            For residents
          </a>
          <Link to="/waitlist">
            <DefaultButton
              buttonType="secondary"
              className="text-sm md:text-base font-medium border-gray-300 dark:border-[#D9D9D9] text-black dark:text-gray-300"
            >
              Join waitlist
            </DefaultButton>
          </Link>
          <Link to="/auth/register" state={{ from: location.pathname }}>
            <DefaultButton className="text-sm md:text-base font-medium bg-black dark:bg-gray-100 text-gray-300 dark:text-black">
              Get Started
            </DefaultButton>

          </Link>
           

          <button
            onClick={() => toggleDarkMode()}
            aria-label="Toggle dark mode"
            className="p-1 rounded-md text-black dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
          >
            {isDarkMode ? <FaMoon className="h-5 w-5" /> : <FaSun className="h-5 w-5" />}
          </button>
        </div>

        <button
          onClick={toggleMobileMenu}
          className="lg:hidden flex items-center justify-center p-2"
          aria-label="Toggle mobile menu"
        >
          {!isMobileMenuOpen ? (
            <HamburgerImg className="fill-black dark:fill-white w-6 h-6" />
          ) : (
            <CloseImg className="w-6 h-6 text-black dark:text-white" />
          )}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
          onClick={toggleMobileMenu}
        ></div>
      )}

      <div
        className={`fixed top-0 right-0 z-50 h-full w-4/5 max-w-sm bg-white p-6 transform transition-transform duration-300 ease-in-out dark:bg-dark-900 lg:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="flex items-center justify-between mb-6">
          <button onClick={toggleMobileMenu} aria-label="Close mobile menu">
            <CloseImg className="w-6 h-6 text-black dark:text-white cursor-pointer" />
          </button>
        </div>
        <MobileNavLinks
          toggleMobileMenu={toggleMobileMenu}
          isDarkMode={isDarkMode || false}
          toggleDarkMode={toggleDarkMode}
        />
      </div>
    </nav>
  )
}

export default NewNavbar
